import { render, staticRenderFns } from "./SDSubStatusEdit.vue?vue&type=template&id=5712cd49&scoped=true"
import script from "./SDSubStatusEdit.vue?vue&type=script&lang=js"
export * from "./SDSubStatusEdit.vue?vue&type=script&lang=js"
import style0 from "./SDSubStatusEdit.vue?vue&type=style&index=0&id=5712cd49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5712cd49",
  null
  
)

export default component.exports